"use client";

import { type ReactNode, useRef } from "react";

import { setupListeners } from "@reduxjs/toolkit/query";
import { Provider } from "react-redux";

import { makeStore, type AppStore } from "./store";

export default function StoreProvider({
  children,
}: {
  children: ReactNode
}) {
  const storeRef = useRef<AppStore>(null);
  if (!storeRef.current) {
    storeRef.current = makeStore();
    setupListeners(storeRef.current.dispatch);
  }

  return <Provider store={storeRef.current}>{children}</Provider>;
}
